import { DotLegalHeader } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import AnnualWheelSubTasks from "../AnnualWheelSubTasks";
import { ActivityFormProps } from "./ActivityForm.types";
import { Box } from "@mui/system";

export type ActivitySubTasksSectionProps = Pick<ActivityFormProps, "model" | "onModelChange" | "readOnly" | "annualWheelActivityId">;

function ActivitySubTasksSection(props: ActivitySubTasksSectionProps) {
    const { translateString } = useTranslation();

    return (
        <Box mb={2}>
            <DotLegalHeader headerStyle={"medium"} marginTop={1} marginBottom={0.5}>
                {translateString("createActivitySubTasks")}
            </DotLegalHeader>
            <AnnualWheelSubTasks
                allowMentions
                readOnly={props.readOnly}
                annualWheelActivityId={props.annualWheelActivityId}
                subTasks={props.model.subTasks}
                onChange={(subTasks) => props.onModelChange({ subTasks })}
            />
        </Box>
    );
}

export default ActivitySubTasksSection;
